import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { FormlyFieldConfig } from "@ngx-formly/core";

@Component({
    templateUrl: "./redeem-coupon.component.html",
    styleUrls: ["./redeem-coupon.component.scss"],
    standalone: false
})
export class RedeemCouponComponent implements OnInit {
	fields: FormlyFieldConfig[] = [
		{
			type: "input",
			key: "code",
			templateOptions: {
				label: "Code",
				required: true,
			},
		},
	];
	form = new UntypedFormGroup({});
	model = { code: undefined };

	constructor(private dialog: MatDialogRef<RedeemCouponComponent>) {}

	ngOnInit() {}

	submit(model: any) {
		this.dialog.close(model.code);
	}

	cancel() {
		this.dialog.close();
	}
}
